import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData, updateData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

const IncomeEdit = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNo: 0,
        ExpenseHeadId: '',
        Remarks: '',
        Amount: 0,
    });


    useEffect(() => {
        fetchData('IncomeApi', `/ExpenseData/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data;
                    setFormData({
                        ...invoiceData,
                        UpdatedBy: userId,
                    });

                }
            })
            .catch((error) => {
                console.error('Error fetching Income Details:', error);
            });
    }, [id]);

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);

        setFormData((prevData) => ({
            ...prevData,
            ExpenseHeadId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));
    };


    useEffect(() => {
        fetchCustomerData();
    }, []);

    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('IncomeApi', `/AccountHead/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)
                const options = data.map((customer) => ({
                    label: customer.Name,
                    value: customer.ID,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching Account Head data:', error);
            });
    };



    const submitData = async (e) => {
        setIsLoading(true);
        if (!formData.ExpenseHeadId || formData.ExpenseHeadId === 0) {
            setErrorMessage('Account head is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.Amount || formData.Amount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
        }));

        updateData('IncomeApi', `${id}`, formData, token)
            .then((response) => {
                setSuccessMessage('Expense Updated successfully!');
                setErrorMessage('');

                history.push('/IncomeIndex');
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);

            })
            .catch((error) => {
                console.error('Expense Create error:', error);
                setIsLoading(false);
            });

    };

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : (type === 'radio' ? (value === 'true') : value),
        }));
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    return (
        <Fragment>

            <div className="container w-full max-w-sm container mt-2 mx-auto" style={{ maxHeight: '900px', height: '500px', overflow: 'auto' }}>
                <style>
                    {`
                        /* Hide scrollbar for Chrome, Safari, and Opera */
                        .container::-webkit-scrollbar {
                        width: 0.5em;
                        }

                        .container::-webkit-scrollbar-track {
                        background: rgba(255,255,255,0);
                        }

                        .container::-webkit-scrollbar-thumb {
                        background-color: rgba(255,255,255,0);
                        border-radius: 4px;
                        }
                        
                        
                    `}
                </style>


                <div>

                    <div className='w-full flex' style={{ marginTop: '10px' }}>
                        <h6 className="productHead flex-grow linkcolorBlack" style={{ fontFamily: 'Times new romans', fontWeight: 'bolder' }}>INCOME EDIT</h6>
                        <Button
                            variant="contained"
                            color="error"
                            component={Link}
                            to="/IncomeIndex"
                            className="linkcolor"
                            style={{
                                marginRight: '8px',
                                background: 'linear-gradient(to right, darkred, slategray)',
                                borderRadius: '50px',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                height: '30px'
                            }}

                        >
                            BACK
                        </Button>

                        <Button
                            variant="contained"
                            style={{
                                marginRight: '8px',
                                background: 'linear-gradient(to right, darkgreen, slategray)',
                                borderRadius: '50px',
                                padding: '10px 20px',
                                color: 'white',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                height: '30px'
                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"}
                        </Button>



                    </div>

                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}


                    <div className="w-full mb-2 flex flex-wrap">
                        <div className="w-full sm:w-3/5 pr-2 mb-2 sm:mb-0"> {/* Adjusted width for smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="customer">
                                Account Head
                                <span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={customerOptions}
                                value={customerOptions.find(option => option.value === formData.ExpenseHeadId)}
                                onChange={handleCustomerSelect}
                                placeholder="Select a Acclount Head"
                                readOnly
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Bill Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                type="date"
                                placeholder="Enter Reference Date"
                                name='BillDate'
                                onChange={handleChange}
                            />
                        </div>
                        <div className="w-full sm:w-1/5 pl-2 hidden sm:block"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Bill No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.BillNo}
                                type="text"
                                placeholder="Enter Reference No"
                                onChange={handleChange}
                            />
                        </div>
                    </div>

                    <div className="w-full mb-2 flex flex-wrap">
                        <div className="w-full sm:w-3/5 pr-2 mb-2 sm:mb-0">
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="rate">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Remarks}
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Remarks"
                                name='Remarks'
                            />
                        </div>

                        <div className="w-full sm:w-1/5 pl-2 mb-2 sm:mb-0"> {/* Adjusted width for smaller screens, and hidden on smaller screens */}
                            <label className="block tracking-wide text-gray text-base font-medium mb-2" htmlFor="packingListDate">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.Amount}
                                type="text"
                                placeholder="Enter Amount"
                                onChange={handleChange}
                                name='Amount'
                                style={{ textAlign: 'right' }}
                            />
                        </div>

                    </div>

                </div>

            </div>
        </Fragment>
    );
}

export default IncomeEdit;
